import React from "react";
import { useState } from "react";
import ReactPaginate from "react-paginate";
import { Row, Col, OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link } from "react-router-dom";
// import ReusableOverlayTrigger from "./ReusableOverlayTrigger";
// import ImageUtils from "./ImageUtils";
// import Search from "../../components/Search";
import ReusableCertifiedIcon from "./ReusableCertifiedIcon";
import DatasetLikes from "./DatasetLikes";
import { BI_PRODUCT_FLAG } from "../../constants/Constant";
import { BsDatabaseFillExclamation } from "react-icons/bs";
import { TbReport } from "react-icons/tb";
import { useLocation } from 'react-router-dom';

// import { FaThumbsUp, FaThumbsDown } from "react-icons/fa";

const ReusableDatasetsContent = (props) => {
  const location = useLocation();
  const isMetricCatalog = location.pathname.includes('metric-catalog');

  // const imageUtil = new ImageUtils();
  const [page, setPage] = useState(props.pageIndex + 1);

  const datasetperpage = 10;
  const datasets = (page - 1) * datasetperpage;
  const totalRecords = props.responseCount;
  const totalPages = Math.ceil(totalRecords / datasetperpage);

  let pageNumber = totalRecords === 0 ? 0 : datasets + 1;
  let recordPerPage = Math.min(datasets + datasetperpage, totalRecords);

  if (totalRecords === 0) {
    pageNumber = 0;
    recordPerPage = 0;
  }

  const changePage = ({ selected }) => {
    props.setPageIndex(selected);
    setPage(selected + 1);
  };

  const style = {
    height: "40px",
    width: "40px",
    paddingBottom: "6px",
    color: "#7EC8E3",
    marginRight: "10px",
  };

  const commonParaStyle = {
    border: "0px solid red",
    display: "flex",
    justifyContent: "space-between",
    fontSize: "13px",
  };

  const individualRow = {
    // border: "2px solid black",
  };

  const individualRow1 = {
    // border: "3px solid green",
    display: "flex",
    justifyContent: "space-between",
    // width:"100%",
  };

  const renderTooltip = (props) => {
    let message = "";

    if (props.popper.state) {
      message = props.popper.state.options.testObj;
    }
    return (
      <Tooltip id="button-tooltip" {...props}>
        {message}
      </Tooltip>
    );
  };

  let displayData = "";
  if (props.filteredata?.length > 0) {
    displayData = props.filteredata
      // ?.slice(datasets, datasets + datasetperpage)
      ?.map((d, index) => {
        let matchedField = "";
        if (d.matchScore) {
          matchedField = `${d.matchFields} (${d.matchScore?.toFixed(2)})`;
        } else {
          matchedField = `${d.matchFields}`;
        }

        return d.fqn ? (
          <div
            key={index}
            className="dataset-overview row"
            style={{ border: "0px solid blue" }}
          >
            <div>
              <div style={individualRow1}>
                {/* <div className="pb-1"> */}
                <div className="">
                  {props.name ? (
                    <div>
                      <div className="d-inline-block">
                        <Link
                          to={`/databook/bicatalog/dashboard/${d.fqn}`}
                          className="widg__f"
                        // rel="noopener noreferrer"
                        >
                          {" "}
                          <span className="fqn_d">{d.name}</span>
                        </Link>
                      </div>

                      {d.certification &&
                        d.certification?.certifiedFlag === true ? (
                        <div className="d-inline-block">
                          {" "}
                          <ReusableCertifiedIcon
                            certifieddata={d.certification}
                          />{" "}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  ) : (
                    <>
                      <div>
                        <div className="d-inline-block">
                          {d.assetType === BI_PRODUCT_FLAG ? (
                            <div>
                              <OverlayTrigger
                                placement="top"
                                overlay={renderTooltip}
                                popperConfig={{ testObj: "BI Product" }}
                              >
                                <span>
                                  {" "}
                                  <TbReport style={style} />
                                </span>
                              </OverlayTrigger>

                              <Link
                                to={`/databook/bicatalog/dashboard/${d.fqn}`}
                                className="widg__f"
                              >
                                <span className="fqn_d">{d.fqn}</span>
                              </Link>
                            </div>
                          ) : (
                            <div
                              style={{
                                border: "0px solid orange",
                                // width: "500px",
                                display: "flex",

                                // justifyContent:"center",
                                // alignItems:"center"
                              }}
                            >
                              <OverlayTrigger
                                placement="top"
                                overlay={renderTooltip}
                                popperConfig={{ testObj: "Dataset" }}
                              >
                                <div
                                  style={{
                                    border: "0px solid blue",
                                    display: "flex",
                                    marginLeft: "0px",
                                  }}
                                >
                                  <BsDatabaseFillExclamation style={style} />

                                  {/* <Link
                                    to={`/databook/datasets/alldatasets/${d.fqn}`}
                                  // target="_blank"
                                  // rel="noopener noreferrer"
                                  > */}
                                    <Link
                                        to={isMetricCatalog ? `/databook/datasets/alldatasets/metric/${d.fqn}` : `/databook/datasets/alldatasets/${d.fqn}`}
                                      // target="_blank"
                                      // rel="noopener noreferrer"
                                      >
                                    <p className="fqn_dextra">{d.name}</p>
                                    <p className="fqn_dextra1">{d.fqn}</p>
                                  </Link>

                                  {d.certification &&
                                    d.certification?.certifiedFlag === true ? (
                                    <div style={{border:"0px solid red",marginLeft: "100px", }} >
                                      <ReusableCertifiedIcon
                                      certifieddata={d.certification} 
                                    />
                                    </div>
                              
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </OverlayTrigger>
                            </div>
                          )}
                        </div>
                        {/* <div className="d-inline-block">
                        {d.certification &&
                        d.certification?.certifiedFlag === true ? (
                          <ReusableCertifiedIcon
                            certifieddata={d.certification}
                          />
                        ) : (
                          ""
                        )}
                      </div> */}
                        {/* <div style={{ border: "1px solid red" }}>
                        <DatasetLikes
                          fqn={d.fqn}
                          likesCount={d.likesCount}
                          updateFilterData={props.updateFilterData}
                          likeColor={d.likeColor}
                        />
                      </div> */}

                        <div></div>
                      </div>
                    </>
                  )}
                </div>
                {/* <div style={{ border: "0px solid green" }}>
                  <DatasetLikes
                    fqn={d.fqn}
                    likesCount={d.likesCount}
                    updateFilterData={props.updateFilterData}
                    likeColor={d.likeColor}
                  />
                </div> */}
              </div>
              <div style={individualRow}>
                {d.description && (
                  <div className="desc_d">
                    {d.show ? (
                      <>
                        {d.alerted_desc}
                        <span
                          className="desc-read-more"
                          onClick={() => props.enableReadMore(d.fqn, false)}
                        >
                          {" "}
                          Read more...
                        </span>
                      </>
                    ) : d.descCount < 131 ? (
                      d.description
                    ) : (
                      <>
                        {d.description}
                        <span
                          className="desc-read-more"
                          onClick={() => props.enableReadMore(d.fqn, true)}
                        >
                          {" "}
                          Read less
                        </span>
                      </>
                    )}
                  </div>
                )}
              </div>
            </div>

            {/* below we have description */}
            {/* <Row className="pb-1">
            {d.description && (
              <>
                <div className="desc_d">
                  Description :{" "}
                  {d.show ? (
                    <>
                      {d.alerted_desc}
                      <span
                        className="desc-read-more"
                        onClick={() => props.enableReadMore(d.fqn, false)}
                      >
                        {" "}
                        Read more...
                      </span>
                    </>
                  ) : d.descCount < 131 ? (
                    d.description
                  ) : (
                    <>
                      {d.description}
                      <span
                        className="desc-read-more"
                        onClick={() => props.enableReadMore(d.fqn, true)}
                      >
                        {" "}
                        Read less
                      </span>
                    </>
                  )}
                </div>
              </>
            )}
          </Row> */}

            {/* <ul className="overlay-tooltip"> */}
            {/* <ul className="">
            {props.name ? (
              <>
                {d.domain?.length > 0 ? (
                  <li>
                    <ReusableOverlayTrigger
                      data={d.domain?.toString()}
                      tipText={"Domain"}
                      icon={imageUtil.getImage(d.domain)}
                    />
                  </li>
                ) : (
                  ""
                )}
              </>
            ) : (
              <>
                {d.domains?.length > 0 ? (
                  <li>
                    <ReusableOverlayTrigger
                      data={d.domains?.toString()}
                      tipText={"Domain"}
                      icon={imageUtil.getImage(d.domains)}
                    />
                  </li>
                ) : (
                  ""
                )}
              </>
            )}

            {d.orgModel && d.orgModel?.length > 0 ? (
              <li>
                <ReusableOverlayTrigger
                  data={d.orgModel}
                  tipText={"By Maersk Model"}
                  icon={imageUtil.getImage(d.orgModel)}
                />
              </li>
            ) : (
              ""
            )}
            {d.securityClassification ? (
              <li>
                <ReusableOverlayTrigger
                  data={d.securityClassification}
                  tipText={"Security Classification"}
                />
              </li>
            ) : (
              "securityClassification"
            )}
            {d.owner && d.owner.toString()?.length > 0 ? (
              <li>
                <ReusableOverlayTrigger
                  data={d.owner.toString()}
                  tipText={"Data Owner"}
                  icon={imageUtil.getImage("Person")}
                />
              </li>
            ) : (
              ""
            )}

            <br />

            {d.tags && d.tags.length > 0 ? (
              <li style={{ paddingLeft: "15px", marginTop: "20px" }}>
                {" "}
                <span>Tags : </span>
                {d.tags.map((tag, index) => (
                  <span
                    key={index}
                    style={{
                      border: "1px solid gray",
                      borderRadius: "30px",
                      padding: "0px 5px",
                      margin: "0px 3px",
                      fontSize: "12px",
                    }}
                  >
                    {tag}
                  </span>
                ))}
              </li>
            ) : (
              "Tags"
            )}

            <br />

            {d.biTool && d.biTool?.length > 0 ? (
              <li>
                <ReusableOverlayTrigger
                  data={d.biTool.toString()}
                  tipText={"BI Tool"}
                />
              </li>
            ) : (
              ""
            )}

            <br />
            {d.matchFields && d.matchFields?.length > 0 ? (
              <li>
                <ReusableOverlayTrigger
                  data={matchedField.toString()}
                  tipText={"Match Fields(Match Score)"}
                />
              </li>
            ) : (
              ""
            )}
            <br />
          </ul>  */}

            {/* {d.owner && d.owner.length > 0 ? (
              <div
                style={{
                  paddingLeft: "12px",
                  marginTop: "10px",
                  marginBottom: "10px",
                }}
              >
                <div>
                  <span>Owner: </span>
                  {d.owner.map((owner, index) => (
                    <span
                      key={index}
                      style={{
                        border: "1px solid #ddd",
                        borderRadius: "30px",
                        padding: "3px 8px",
                        margin: "0px 3px",
                        fontSize: "12px",
                      }}
                    >
                      {owner}
                    </span>
                  ))}
                </div>
              </div>
            ) : (
              ""
            )} */}

            {d.tags && d.tags.length > 0 ? (
              <div
                style={{
                  paddingLeft: "12px",
                  marginBottom: "10px",
                  marginTop: "10px",
                  marginLeft: "30px",
                }}
              >
                <>
                  <span>Tags: </span>
                  {d.tags.map((tag, index) => (
                    <span
                      key={index}
                      style={{
                        border: "1px solid #ddd",
                        borderRadius: "30px",
                        padding: "3px 8px",
                        margin: "0px 3px",
                        fontSize: "12px",
                      }}
                    >
                      {tag}
                    </span>
                  ))}
                </>
              </div>
            ) : (
              ""
            )}

            {/* <Row className="pb-1"> */}
            {/* <Col> */}
            {/* <p>
                <strong>Layer :</strong> {d.layer || "Layer :"}
              </p> */}
            {/* <p style={commonParaStyle}>
                  <span>
                    Data-SetSchema: <strong>{d.datasetSchema || "N/A"}</strong>
                  </span>
                  <span>
                    Layer: <strong>{d.layer || "N/A"}</strong>
                  </span>
                </p> */}
            {/* <p>
                <strong>Format :</strong> {d.format || "Format :"}
              </p> */}
            {/* <p>
                <strong>Match Asset:</strong> {d.matchAsset || "N/A."}
              </p> */}
            {/* <p>
                <strong>Sensitivity:</strong> {d.sensitivity || "N/A."}
              </p> */}
            {/* <p style={commonParaStyle}>
                  <span>
                    Product: <strong>{d.product || "N/A"}</strong>
                  </span>
                  <span>
                    <span>
                      {d.size?.total ? `Size: ${d.size.total} GB` : ""}
                    </span>
                  </span>
                </p>
                <p style={commonParaStyle}>
                  <span>
                    Platform:{" "}
                    <strong>
                      {d.platforms ? d.platforms.join(", ") : "N/A"}
                    </strong>
                  </span>
                  <span>
                    {d.metadataDQScore
                      ? `Metadata DQ Score: ${d.metadataDQScore}`
                      : ""}
                  </span>
                </p>

                <p style={commonParaStyle}>
                  <span>
                    By Maersk:{" "}
                    <strong>
                      {d.orgModels ? d.orgModels.join(", ") : "N/A"}
                    </strong>{" "}
                  </span>
                  <span>
                    {d.datasetDQScore ? `${d.datasetDQScore}/100` : ""}
                  </span>
                </p>

                <p style={commonParaStyle}>
                  <span>
                    Business:{" "}
                    <strong>
                      {d.businesses ? d.businesses.join(", ") : "N/A"}
                    </strong>{" "}
                  </span>
                  <span>
                    <span>
                      {d.stewards && d.stewardInitials
                        ? `Steward Initials: ${d.stewardInitials} (steward)`
                        : ""}
                    </span>
                  </span>
                </p>

                <p style={commonParaStyle}>
                  <span>
                    Match Score:{" "}
                    <strong>
                      {d.matchScore ? d.matchScore.toFixed(2) : "N/A"}
                    </strong>{" "}
                  </span>

                  <span>
                    {d.owner && d.ownerInitials
                      ? `Owner Initials: ${d.ownerInitials} (owner)`
                      : ""}
                  </span>
                </p> */}
            {/* <p
                style={{
                  border: "0px solid red",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <span>
                  <strong>Refresh Frequency:</strong>{" "}
                  {d.refreshFrequency || "N/A"}
                </span>
                <span>
                  {d.stewards && d.stewardInitials
                    ? `Steward Initials: ${d.stewardInitials} (steward)`
                    : "Steward Initials: Initials"}
                </span>
              </p> */}
            {/* </Col> */}

              {/* from 583 to 658 old code for reference */}
              <Row style={{border: "0px solid red", display: "grid", gridTemplateColumns: "repeat(4, 1fr)", marginLeft: "18px", marginTop:"0px" }}>
                    {/* Dataset Schema */}
                    {/* {d?.datasetSchema && (
                      <Col>
                        <p style={commonParaStyle}>
                          <span>Dataset Schema: {d.datasetSchema || "--"}</span>
                        </p>
                      </Col>
                    )} */}

                    {/* Product */}
                    {d.product && (
                      <Col>
                        <p style={commonParaStyle}>
                          <span>Product: {d.product || "--"}</span>
                        </p>
                      </Col>
                    )}

                    {/* Portfolio */}
                    {d?.orgModels && (
                      <Col>
                        <p style={commonParaStyle}>
                          <span>Portfolio: {d.orgModels ? d.orgModels.join(", ") : "--"}</span>
                        </p>
                      </Col>
                    )}

                    {/* Platform */}
                    {d?.platforms && (
                      <Col>
                        <p style={commonParaStyle}>
                          <span>Platform: {d.platforms ? d.platforms.join(", ") : "--"}</span>
                        </p>
                      </Col>
                    )}

                    {/* Storage Account */}
                    {d?.layer && (
                      <Col>
                        <p style={commonParaStyle}>
                          <span>Storage Account: {d.layer || "--"}</span>
                        </p>
                      </Col>
                    )}

                    {/* Metadata DQ Score */}
                    {d?.metadataDQScore && (
                      <Col>
                        <p style={commonParaStyle}>
                          <span>Metadata DQ Score: {d.metadataDQScore || "--"}</span>
                        </p>
                      </Col>
                    )}
                    

                    {/* Search Match Score */}
                    {/* // Commented as of now, will discuss and enable in future */}
                    {/* {d?.matchScore > 0 && (
                      <Col>
                        <p style={commonParaStyle}>
                          <span>Search Match Score: {d.matchScore ? d.matchScore.toFixed(2) : "--"}</span>
                        </p>
                      </Col>
                    )} */}
                  </Row>

            {/* <Row style={{display:"grid", gridTemplateColumns:"repeat(4, 1fr)"}}>
              {d?.stewardInitials && (
                <Col>
                  <p style={commonParaStyle}>
                    <span>
                      Steward Initials:{" "}
                      {d.stewards && d.stewardInitials
                        ? `${d.stewardInitials} (steward)`
                        : "--"}
                    </span>
                  </p>
                </Col>
              )}
              {d?.ownerInitials && (
                <Col>
                  <p style={commonParaStyle}>
                    <span>
                      Owner Initials:{" "}
                      {d.owner && d.ownerInitials
                        ? `${d.ownerInitials} (owner)`
                        : "--"}
                    </span>
                  </p>
                </Col>
              )}
              {d?.datasetDQScore && (
                <Col>
                  <p style={commonParaStyle}>
                    <span>
                      Dataset DQ Score:{" "}
                      {d.datasetDQScore ? `${d.datasetDQScore}/100` : "--"}
                    </span>
                  </p>
                </Col>
              )}
              <Col></Col>
            </Row> */}

            {/* <Col className="text-right" style={{ border: "3px solid red" }}>
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip>
                    Last modified: DD-MM-YYYY
                    <br />
                    Rows: {d.size?.rows || "Rows"}
                    <br />
                    Columns: {d.size?.columns || "Columns"}
                  </Tooltip>
                }
              >
                <p>
                  <span>
                    {d.datasetDQScore
                      ? `${d.datasetDQScore}/100`
                      : "datasetDQScore"}
                  </span>
                  <br />

                  {d.metadataDQScore
                    ? `${d.metadataDQScore}`
                    : "metadataDQScore"}

                  <br />
                  {d.size?.total ? `${d.size.total} GB` : "SIZE"}
                  <br />
                  {d.owner && d.ownerInitials
                    ? `Owner Initials: ${d.ownerInitials} (owner)`
                    : "Owner Initials: Initials"}
                  <br />
                  {d.stewards && d.stewardInitials
                    ? `Steward Initials: ${d.stewardInitials} (steward)`
                    : "Steward Initials: Initials"}
                </p>
              </OverlayTrigger>
            </Col> */}
            {/* </Row> */}

            {/* <Row>
            <Col className="text-right" style={{ border: "3px solid red" }}>
              <span>
                {d.owner && d.ownerInitials
                  ? `Owner Initials: ${d.ownerInitials} (owner)`
                  : "Owner Initials: Initials"}
                <br />
                {d.stewards && d.stewardInitials
                  ? `Steward Initials: ${d.stewardInitials} (steward)`
                  : "Steward Initials: Initials"}
              </span>
            </Col>
          </Row> */}
          </div>
        ) : (
          ""
        );
      });
  } else {
    displayData = (
      <div className="mt-5">
        <Row>
          <center>No Records Found.</center>
        </Row>
      </div>
    );
  }
  return (
    <Col className="main_content">
      <Row className="d-sm-flex align-items-center justify-content-between border-bottom pb-2">
        <Col className="d-none d-sm-inline-block page_info">
          Showing <span>{pageNumber}</span> to <span>{recordPerPage}</span> of{" "}
          <span>{totalRecords}</span> results
        </Col>
        <Col className="col-3">
          {/* <Search
            divstyle="justify-content-end " //d-flex  mb-2 bg-white
            placeHolder="Search by fqn"
            iconSize={20}
            searchFunc={props.searchcolumns}
            innerwrapper="custom-border" 
          /> */}
        </Col>
      </Row>
      <>
        {displayData}
        <Col className="dataset_pagination mt-1 mb-5">
          <ReactPaginate
            previousLabel={"Previous"}
            nextLabel={"Next"}
            pageCount={totalPages}
            onPageChange={changePage}
            containerClassName={"navigationButtons"}
            previousLinkClassName={"previousButton"}
            nextLinkClassName={"nextButton"}
            disabledClassName={"navigationDisabled"}
            activeClassName={"navigationActive"}
            renderOnZeroPageCount={null}
            forcePage={page - 1}
          />
        </Col>
      </>
    </Col>
  );
};

export default ReusableDatasetsContent;
